import { StaticImage } from "gatsby-plugin-image";
import { forwardRef, SVGAttributes, Ref } from "react";

interface LogoProps extends SVGAttributes<SVGSVGElement> {
  /**
   * For use on a light or dark background.
   * @default 'light'
   */
  variant?: "light" | "dark";
}

/**
 * The company logo
 */
const Logo = ({ ...props }: LogoProps, ref: Ref<SVGSVGElement>) => {
  return (
    <>
      <span
        sx={{
          display: ["none", null, null, "block"],
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={ref}
          viewBox="0 0 397.04 46.86"
        >
          <title>Cash Money</title>
          <g data-name="Layer 2">
            <g data-name="Layer 1">
              <path
                d="M379.42 1.11l-22.74 31.4-3.15 13.22h-15l3.08-12.87-6-25.23-1.42 5.92H319.9l-.86 3.6h13.53l-2.84 11.93h-13.54l-1 4h14.31l-3 12.62h-29.27l10.64-44.59h42.7L352 8.92a82.41 82.41 0 011.2 8.32c1.92-3.26 3.81-6.09 5.55-8.58L364 1.11zm-85.93 44.62H273.2l-4.28-15.53a54 54 0 01-1.2-7.3l-1 4-4.48 18.79h-14.39l3.58-15c-5.77 9.84-16.77 15.92-26.92 15.92-9 0-15-3.54-17.16-9.81l-.78 8.87h-16l1.69-16.65c.23-2.32.62-5.66 1-8.41-1.59 3.6-3.27 7.21-4.7 10.13l-7.39 14.93H166v-13.5c0-3.09.13-7.38.32-11.24-1.11 3.26-2.15 6.26-3.17 9.18l-5.6 15.62h-15l17.5-44.62h19l.41 16.39c0 1.88-.08 4.81-.33 8.24 1.43-3.27 2.74-6 4-8.41l8.44-16.22h18.91l-1.57 18.05C214 7.58 226.25.17 237.31.17c9.24 0 17.18 4 18.15 13.67l3-12.73h20.29l4 14.76a79.28 79.28 0 011.62 7.89c.43-2.14.94-4.29 1.39-6.18l3.93-16.47h14.44zm-55-22.49c1.43-6-1.2-9-5.36-9-4 0-8.21 3-9.65 9s1 9.27 5.13 9.27c3.76 0 8.24-2.4 9.89-9.27zm152.07-18.3a4 4 0 00-1.87-.33h-1.31v3.17h1.39a4.21 4.21 0 001.47-.19 1.35 1.35 0 00.9-1.37 1.32 1.32 0 00-.58-1.28zm-1.66-1.38a6.7 6.7 0 012.39.31 2.17 2.17 0 011.36 2.22 1.9 1.9 0 01-.86 1.73 3.31 3.31 0 01-1.27.42 2.15 2.15 0 011.48.86 2.4 2.4 0 01.48 1.36v1.29a1.9 1.9 0 00.07.46l-1.38.11-.08-.47v-.7a2.13 2.13 0 00-.83-2 3.66 3.66 0 00-1.72-.29h-1.21v3.46h-1.55V3.56zm-4.7-.46a6.65 6.65 0 00-2 4.86 6.73 6.73 0 002 4.89 6.83 6.83 0 009.72 0 6.71 6.71 0 002-4.89 6.62 6.62 0 00-2-4.86 6.84 6.84 0 00-9.71 0zm10.51 10.52a8 8 0 01-11.3 0A7.74 7.74 0 01381.09 8a7.69 7.69 0 012.34-5.64 8 8 0 0111.28 0A7.65 7.65 0 01397 8a7.71 7.71 0 01-2.29 5.62z"
                fillRule="evenodd"
                fill="#D91828"
              />
              <path
                d="M101.72 36.16c-2.5 6.4-9.2 10.7-20.58 10.7a38.3 38.3 0 01-7.47-1v-.25H59.8l-1.72-5.58H44.52l-1.71 5.58H30.87a39.75 39.75 0 01-7.78.77c-15.71 0-23.09-9-23.09-22C0 12.18 8.07.09 25.74.09a30.35 30.35 0 017.9 1l-1.37 13.59a22.47 22.47 0 00-6.87-1.12c-4.55 0-8.41 3.17-8.41 9.52s4 9.27 8.84 9.27A15.62 15.62 0 0032 31.27L42.46 1h19.23L74 36.5l.16-4a22.23 22.23 0 008.23 1.38c2.41 0 3.1-1.29 3.1-2.06 0-3.78-13.65-.77-13.65-15.79 0-9.53 6.78-16 20.6-16a55 55 0 017.12.6l-.43 12.87a25.14 25.14 0 00-7.21-1c-2.4 0-3.09.86-3.09 2.06 0 2.48 9.53 2.39 12.86 9.61V1h15.79v15.22h13.73V1H147v44.7h-15.76V30h-13.73v15.66h-15.79zm-47.16-7.24l-1.71-5.58c-.52-1.54-1.2-3.69-1.63-5.58-.43 1.72-.95 3.61-1.38 5.07L48 28.92z"
                fill="#231f20"
                fillRule="evenodd"
              />
            </g>
          </g>
        </svg>
      </span>

      <StaticImage
        sx={{ display: ["block", null, null, "none"], width: 70 }}
        src="../../images/CM_logo_abbre.png"
        alt="Cash Money Logo"
        placeholder="none"
      />
    </>
  );
};

const forwarded = forwardRef<SVGSVGElement, LogoProps>(Logo);

export { forwarded as Logo };
